import LiteLayout from '@/components/layout/lite/LiteLayout';
import { useAppDispatch, useAppSelector } from '@/state/hooks';
import { controlInitSubscriptions, selectCredentials } from '@/state/reducers/authSlice';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import LiteBalances from '@/components/lite-modules/LiteBalances';
import LiteMarkets from '@/components/lite-modules/LiteMarkets';
import { fetchUserMarkets } from '@/state/reducers/marketPairSlice';
import { isCorrectLayout } from '@/utils/route';

const xplorspotliteEnabled = window.config?.layout?.xplorspotlite?.enabled;

function XplorSpotLite() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const credentials = useAppSelector(selectCredentials);

    useEffect(() => {
        if (!credentials) {
            navigate('/login');
        } else {
            if (isCorrectLayout('xplorspotlite')) {
                if (xplorspotliteEnabled) {
                    // Fire initial requests
                    dispatch(controlInitSubscriptions());
                    dispatch(fetchUserMarkets());
                } else {
                    navigate('/');
                }
            } else {
                navigate('/trader');
            }
        }
    }, []);

    return credentials ? (
        <LiteLayout>
            <div className="flex w-full gap-5 sm:gap-6 p-2 sm:p-6 flex-col-reverse md:flex-row text-brand-text">
                <LiteBalances />
                <LiteMarkets />
            </div>
        </LiteLayout>
    ) : null;
}

export default XplorSpotLite;
